
import respUtility from '~/mixins/respUtility';

export default {
  name: 'ListingFooterFilters',
  mixins: [respUtility],
  props: {
    filters: {
      type: Array,
      required: true,
    },
    header: {
      type: String,
      required: '',
    },
  },
  computed: {
    mobileFilters() {
      return [this.filters];
    },
  },
  methods: {
    scrollTop(e) {
      if (e?.target?.tagName !== 'A') {
        return;
      }
      this.$nextTick(() => {
        const el = document.querySelector('#listing-products');
        if (!el) {
          return;
        }
        el.scrollIntoView({ behavior: 'smooth' });
      });
    },
  },
};
